// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customUserDropdownContainer {
  display: flex;
  flex-direction: column;
  z-index: 1002;
  margin-bottom: 20px;
  width: 48%;
}

.customUserDropdownLabel {
  color: #e51b22;
  margin-bottom: 5px;
  font-weight: 700;
}

.customUserDropdown {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  background-color: #f3f3f3;
  border: none;
  border-bottom: 1px solid #000000;
  font-size: 16px;
  padding-top: 4px;
  padding-bottom: 4px;
}

.react-user-select__control {
  border: none !important;
  background-color: #f3f3f3 !important;
  padding: 0 !important;
  box-shadow: none !important;
}

.react-user-select__indicator-separator {
  display: none;
}

.userSelectLabel {
  display: flex;
  flex-direction: row;
}

.userSelectLabelText {
  font-size: 15px;
  line-height: 30px;
}

.userSelectAvatar {
  margin-right: 10px;
  border-radius: 30px;
  height: 30px;
  width: 30px;
}`, "",{"version":3,"sources":["webpack://./src/components/UserSelect/UserSelect.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb","sourcesContent":[".customUserDropdownContainer {\n  display: flex;\n  flex-direction: column;\n  z-index: 1002;\n  margin-bottom: 20px;\n  width: 48%;\n}\n\n.customUserDropdownLabel {\n  color: #e51b22;\n  margin-bottom: 5px;\n  font-weight: 700;\n}\n\n.customUserDropdown {\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n  background-color: #f3f3f3;\n  border: none;\n  border-bottom: 1px solid #000000;\n  font-size: 16px;\n  padding-top: 4px;\n  padding-bottom: 4px;\n}\n\n.react-user-select__control {\n  border: none !important;\n  background-color: #f3f3f3 !important;\n  padding: 0 !important;\n  box-shadow: none !important;\n}\n\n.react-user-select__indicator-separator {\n  display: none;\n}\n\n.userSelectLabel {\n  display: flex;\n  flex-direction: row;\n}\n\n.userSelectLabelText {\n  font-size: 15px;\n  line-height: 30px;\n}\n\n.userSelectAvatar {\n  margin-right: 10px;\n  border-radius: 30px;\n  height: 30px;\n  width: 30px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
